var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"collect-step2"},[_c('el-image',{staticStyle:{"width":"500px","height":"500px"},attrs:{"src":"https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/gif/20250815104437tongue_bottom_gif.gif"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }